module.exports = __webpack_public_path__ + "static/media/office_2@2x.ce05fac4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/office_2@2x.jpg
// module id = 160
// module chunks = 0